/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-25 17:57:18
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:03:13
 * @FilePath: /unifyxp-v2-store-portal/src/components/InputBreakTag/Tag.tsx
 */
import { PlusOutlined } from '@ant-design/icons';
import { Tag as TagAntd } from 'antd';
import React from 'react';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import css from './Tag.less';
interface IProps {
  tagType: 'InputBreak';
  tagClose?: (e, index) => void;
  children;
  index?: number;
  disabled?: boolean;
}
export default (props: IProps) => {
  const { tagType, tagClose, children, index, disabled, ...rest } = props;
  return (
    <TagAntd
      className={tagType == 'InputBreak' && css.searchList}
      color='#eeeeee'
      closable={!disabled}
      visible
      onClose={(e) => tagClose && !disabled && tagClose(e, index)}
      {...rest}>
      {children}
    </TagAntd>
  );
};

const _Tag = (props) => {
  const { text, children, className, textWidth, ...rest } = props;
  return (
    <TagAntd className={`${css.tag} ${className || ''}`} {...rest}>
      <div {...(textWidth ? { style: { maxWidth: textWidth } } : {})}>
        <NoWrapContainer>
          <GlobalTooltip title={text}>{text}</GlobalTooltip>
        </NoWrapContainer>
      </div>
      {children}
    </TagAntd>
  );
};

const AddableTag = (props) => {
  const { text, className, ...rest } = props;
  return (
    <_Tag
      text={text}
      className={`${css.searchList} ${className || ''}`}
      color='#eeeeee'
      visible
      {...rest}>
      <PlusOutlined className={css.addIcon} />
    </_Tag>
  );
};
const ClosableTag = (props) => {
  const { onClose, index, text, className, closable = true, ...rest } = props;
  console.log('closable: ', closable);
  return (
    <_Tag
      text={text}
      className={`${css.searchList} ${className || ''}`}
      color='#eeeeee'
      closable={closable}
      visible
      onClose={(e) => onClose && onClose(e, index)}
      {...rest}
    />
  );
};
export { AddableTag, ClosableTag };
